import axios from 'axios';

const API_BASE_URL = 'https://boxy.currenmexico.com/legalback';
//const API_BASE_URL = 'http://localhost:3005/legalback';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const loginClient = async (email, password) => {
  try {
    const response = await api.post('/client_login', {
      client_email: email,
      client_password: password,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const loginLawyer = async (email, password) => {
  try {
    const response = await api.post('/lawyer_login', {
      lawyer_email: email,
      lawyer_password: password,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const registerClient = async clientData => {
  try {
    console.log('data = ', clientData);

    const response = await api.post('/post_client', clientData);

    console.log('Response.data = ', response.data);

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getGenders = async () => {
  try {
    const response = await api.get('/get_gender');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getOccupations = async () => {
  try {
    const response = await api.get('/get_client_ocupation');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getHowYouMeet = async () => {
  try {
    const response = await api.get('/get_client_forma_conocernos');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Endpoints para catálogos de abogados
export const getCountries = async () => {
  try {
    const response = await api.get('/getcountries');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getStates = async (countryId = 142) => {
  try {
    const response = await api.get(`/getStates?country=${countryId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCities = async stateId => {
  try {
    const response = await api.get(`/getCities?state=${stateId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerLanguages = async () => {
  try {
    const response = await api.get('/get_lawyer_languages');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerPrices = async () => {
  try {
    const response = await api.get('/get_lawyer_precios');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerSpecialties = async () => {
  try {
    const response = await api.get('/get_lawyer_especialidades');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerPositions = async () => {
  try {
    const response = await api.get('/get_lawyer_position');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Nuevas funciones para catálogos de búsqueda (BuscaAbogado y ConsultaExpress)
export const getCatalogStates = async (countryId = 142) => {
  try {
    const response = await api.get(`/states?country=${countryId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCatalogCities = async stateId => {
  try {
    const response = await api.get(`/cities?state=${stateId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Registro de abogado
export const registerLawyer = async lawyerData => {
  try {
    const response = await api.post('/post_lawyer', lawyerData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
